module.exports = __webpack_public_path__ + "img/logo_barmanager_white.31156fe5.svg";